import type { UpdateRequestById } from "@nlc/shared-types";

import apiClient from "@/lib/api/client";

/**
 * Create an empty request draft in the real requests system so the MBC brief
 * shows up in the app's Drafts list alongside normal requests. Mirrors the
 * blank-draft creation the classic create flow uses (`POST /requests`).
 *
 * Returns the new MySQL request id so the caller can pair it with the MBC draft
 * (the pairing is stored on the Mongo side, keyed by this id).
 */
export async function createEmptyRequestDraft(
  projectId: number,
): Promise<number> {
  // isMbc is only settable at creation (no update path writes it) — this is
  // the sole caller, so it's hardcoded here rather than threaded through as
  // a parameter.
  const { requestId } = await apiClient
    .url("/requests")
    .post({ isMbc: true, projectId, requestType: "graphic" })
    .json<{ requestId: number }>();

  return requestId;
}

/**
 * PATCHes the brief's identity — name, brand, design type — onto the request
 * T8 already created (D5). Reuses the classic edit form's endpoint; MBC only
 * ever needs this subset of `UpdateRequestById`, so the caller passes an
 * exact subset rather than the full editable-field union.
 */
export async function updateRequestDraft(
  requestId: number,
  data: Pick<UpdateRequestById, "brandId" | "designTypeId" | "name">,
): Promise<void> {
  await apiClient.url(`/requests/edit/${requestId}`).patch(data).json();
}
